import type { ComponentType } from 'react'
import FleetJobDetails from './details/FleetJobDetails'
import GenericParamsDetails from './details/GenericParamsDetails'
import ScrapeCommentFetchDetails from './details/ScrapeCommentFetchDetails'
import { API_COMMENT_FETCH_KIND, API_POST_FETCH_KIND, SCRAPE_COMMENT_FETCH_KIND } from './tags'
import type { WorkRow } from './work-row'

/**
 * What the details panel shows for one kind. Only the settings body is
 * per kind today; the header, latest outcome and run history are the
 * same for every row.
 */
export type KindDetails = {
    Settings: ComponentType<{ row: WorkRow }>
}

/**
 * The list is generic and grows no per-kind columns. This is where a kind
 * gets its own rendering instead: keyed by the kind string the row
 * carries, same shape as `platforms.ts`. A kind with no entry is not
 * hidden; it gets its params as key and value.
 */
const KIND_DETAILS: Record<string, KindDetails> = {
    [SCRAPE_COMMENT_FETCH_KIND]: { Settings: ScrapeCommentFetchDetails },
    [API_POST_FETCH_KIND]: { Settings: FleetJobDetails },
    [API_COMMENT_FETCH_KIND]: { Settings: FleetJobDetails }
}

const FALLBACK: KindDetails = { Settings: GenericParamsDetails }

export function detailsFor(kind: string): KindDetails {
    return KIND_DETAILS[kind] ?? FALLBACK
}
